import { useState } from "react"
import { useDispatch } from "react-redux"
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { toast } from "react-toastify"
import { selector } from "../../../api"
import { authCRUD, authActions } from "../../../actions/auth"

const userSchema = Yup.object().shape({
  email: Yup.string().email('Wrong email format').min(3, 'Minimum 3 symbols'),
})

export const ProfileContent = () => {

  const user = selector.User()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const initialValues = {
    first_name: user.first_name,
    last_name: user.last_name,
    email: user.email,
    phone_number: user.phone_number || '',
  }

  const formik = useFormik({
    initialValues,
    validationSchema: userSchema,
    onSubmit: (values, { setSubmitting }) => {
      const { first_name, last_name, email, phone_number } = values
      const data = { first_name, last_name, email, phone_number }
      setLoading(true)
      setTimeout(() => {
        authCRUD.updateUser(user.id, data).then(() => {
          authCRUD.loadUser(user.username).then((resp) => {
            dispatch(authActions.getUser(resp.data))
            toast.success('Your profile has been update.', { autoClose: 7000 })
          }).catch((error) => {
            toast.error(error, { autoClose: 7000 })
          })
        }).catch((error) => {
          toast.error(error, { autoClose: 7000 })
        }).finally(() => {
          setLoading(false)
          setSubmitting(false)
        })
      }, 2000)
    }
  })

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xxl-3">
                <div className="card">
                  <div className="card-body p-4">
                    <div className="text-center">
                      <h5 className="fs-16 mb-1 mt-2">{user.first_name} &nbsp; {user.last_name}</h5>
                      <p className="text-muted mb-0">{user.email}</p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-5">
                      <div className="flex-grow-1">
                        <h5 className="card-title mb-0">Complete Your Profile</h5>
                      </div>
                    </div>
                    <div className="progress animated-progress custom-progress progress-label">
                      <div className="progress-bar bg-success" role="progressbar" style={{ width: "90%" }} aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                        <div className="label">90%</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xxl-9">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <i className="fas fa-home me-1"></i> Personal Details
                    </h5>
                  </div>
                  <div className="card-body p-4">
                    <form onSubmit={formik.handleSubmit}>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label htmlFor="firstnameInput" className="form-label">First Name</label>
                            <input type="text" className="form-control" id="firstnameInput" placeholder="Enter your firstname" {...formik.getFieldProps('first_name')} />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label htmlFor="lastnameInput" className="form-label">Last Name</label>
                            <input type="text" className="form-control" id="lastnameInput" placeholder="Enter your lastname" {...formik.getFieldProps('last_name')} />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label htmlFor="phonenumberInput" className="form-label">Phone Number</label>
                            <input type="text" className="form-control" id="phonenumberInput" placeholder="Enter your phone number" {...formik.getFieldProps('phone_number')} />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label htmlFor="emailInput" className="form-label">Email Address</label>
                            <input type="email" className="form-control" id="emailInput" placeholder="Enter your email" {...formik.getFieldProps('email')} />
                            {formik.touched.email && formik.errors.email && (
                              <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                                <span role='alert' className='text-danger'>{formik.errors.email}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="mb-3">
                            <label htmlFor="usernameInput" className="form-label">Username</label>
                            <input type="text" className="form-control" id="usernameInput" value={user.username} readOnly />
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="hstack gap-2 justify-content-end">
                            <button type='submit' className="btn btn-soft-success" disabled={formik.isSubmitting || !formik.isValid}>
                              {!loading && <span className='indicator-label'><i className="las la-save la-lg"></i> save changes </span>}
                              {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                  Please wait...
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
